import { render, staticRenderFns } from "./BarcodeElement.vue?vue&type=template&id=19b5f847&scoped=true&"
import script from "./BarcodeElement.vue?vue&type=script&lang=js&"
export * from "./BarcodeElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b5f847",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b5f847')) {
      api.createRecord('19b5f847', component.options)
    } else {
      api.reload('19b5f847', component.options)
    }
    module.hot.accept("./BarcodeElement.vue?vue&type=template&id=19b5f847&scoped=true&", function () {
      api.rerender('19b5f847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/BarcodeElement.vue"
export default component.exports